<style>
.dialog-off-canvas-main-canvas {
  border: 2px dotted green;
}
</style>

{% include '@components/control-bar.twig' %}
{% include '@components/toolbar.twig' %}
{% include '@components/extra-sidebar.twig' %}
<div class="dialog-off-canvas-main-canvas">
  canvas content
</div>